import { DecimalPipe, NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { CardComponent } from '@sportello-balneari/shared-components';

@Component({
  selector: 'lib-result-analyses-card',
  standalone: true,
  imports: [NgStyle, CardComponent, DecimalPipe],
  templateUrl: './analyses-card.component.html',
})
export class ResultAnalysesCardComponent {
  score = input<number | null | undefined>();
  maxScore = input<number | null | undefined>();
  technicalScore = input<number | null | undefined>();
  technicalMaxScore = input<number | null | undefined>();
  economicScore = input<number | null | undefined>();
  economicMaxScore = input<number | null | undefined>();
  description = input<string | null | undefined>();

  scoreQuality = computed(() => {
    const score = this.score();
    if (score === undefined || score === null) return '';

    const maxScore = this.maxScore();
    if (maxScore === undefined || maxScore === null || maxScore === 0) return '';

    const perc = score / maxScore;
    if (perc >= 0.8) return 'high';
    if (perc >= 0.4) return 'medium';
    return 'low';
  });

  /** The technical breakdown line is shown only when technical scores are provided. */
  readonly showTechnicalBreakdown = computed(
    () =>
      this.technicalScore() !== undefined &&
      this.technicalScore() !== null &&
      this.technicalMaxScore() !== undefined &&
      this.technicalMaxScore() !== null,
  );

  /** The economic breakdown line is shown only when economic scores are provided. */
  readonly showEconomicBreakdown = computed(
    () =>
      this.economicScore() !== undefined &&
      this.economicScore() !== null &&
      this.economicMaxScore() !== undefined &&
      this.economicMaxScore() !== null,
  );

  /**
   * The technical/economic/total breakdown is only meaningful — and only adds
   * up — when BOTH the technical and economic parts are present. With just one
   * part, the big total already says everything and "Tecnica X = Totale Y"
   * would look mathematically wrong.
   */
  readonly showScoreBreakdown = computed(
    () => this.showTechnicalBreakdown() && this.showEconomicBreakdown(),
  );
}
